import { fun_PostAction, fun_Download } from "@/api/index";
import { fun_DownloadFile, fun_GetKeys } from "@/utils/validate";
import PrintDialog from "../../components/PrintDialog/index.vue";

// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 列表loading状态
      loading: false,
      // 查询表单字段
      form: {
        prjName: null, // 项目名称
        regulators: null // 招标监管部门
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "工程名称：",
          value: "prjName",
          placeholder: "请输入"
        },
        {
          type: "select",
          label: "行政监督部门：",
          value: "regulators",
          placeholder: "请选择",
          disabled: false,
          queryParams: {
            url: "/regulatorsCombobox",
            processType: "201510311952460006"
          }
        }
      ],
      // 温馨提示
      tipList: [],
      // 表头按钮组
      btnList: [
        {
          name: "添加",
          type: "success",
          icon: "document-add"
        },
        {
          name: "修改",
          type: "primary",
          icon: "edit"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "工程名称",
          prop: "prjName",
          width: "380",
          isShow: true,
          fixed: true
        },
        {
          label: "状态",
          slotName: "state",
          fixed: true,
          width: "150"
        },
        {
          label: "打印",
          slotName: "print",
          fixed: true,
          width: "130"
        },
        {
          label: "操作",
          slotName: "op",
          fixed: true,
          width: "190"
        },
        {
          label: "施工方确认日期",
          prop: "sealDate",
          width: "170"
        },
        {
          label: "监管部门",
          prop: "regulatorsName",
          width: "300"
        },
        {
          label: "建设单位",
          prop: "buildCorp",
          width: "280"
        },
        {
          label: "立项批准文号",
          prop: "noteNumber",
          width: "150"
        },
        {
          label: "施工单位",
          prop: "constructionUnitName",
          width: "280"
        },
        {
          label: "计划工期（日历天）",
          prop: "planTimeLimit",
          width: "170"
        },
        {
          label: "工程造价（万元）",
          prop: "projectCost",
          width: "150"
        }
      ],
      // 表格数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 勾选的数组
      multipleSelection: [],
      userFlag: sessionStorage.getItem("userFlag"), // 用户标识
      userType: sessionStorage.getItem("loginType") // 用户类型
    };
  },
  // 注册组件
  components: {
    PrintDialog
  },

  // 模板编译完成
  mounted() {
    // 获取用户信息
    this.fun_GetUser();
    // 获取一览
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
     * 获取用户信息
     * @returns {Promise<void>}
     */
    async fun_GetUser() {
      // 如果用户标识是工作人员或者监管人员
      if ("工作人员" == this.userFlag || "监管人员" == this.userFlag) {
        // 表头按钮组
        this.btnList = [
          {
            name: "台帐导出",
            type: "success"
          }
        ];
      }
    },
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction("/contractRecordDirectly/list", {
          ...this.form,
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      this.form[i] = e;
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 滕威
     */
    fun_click(e) {
      switch (e) {
        case "添加":
          // 跳转详情页面
          this.$router.push({
            path: "/contractRecordDirectlyDetail",
            query: { controllerFlg: "insert" }
          });
          break;
        case "修改":
          // 调用修改方法
          this.fun_Edit();
          break;
        case "删除":
          // 调用修改方法
          this.fun_Del();
          break;
        case "台帐导出":
          // 调用台账导出方法
          this.fun_ImportExcel();
          break;
        default:
          "";
      }
    },
    /**
     * 修改的方法
     * @author shuhua
     */
    fun_Edit() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 如果勾选超过1条
        if (this.multipleSelection.length > 1) {
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
          return;
        } else {
          // 状态
          let state = this.multipleSelection[0].state;
          // 是否审核通过
          let isAuditOk = this.multipleSelection[0].isAuditOk;
          // 如果审核中或者审核通过
          if (
            state == "shz" ||
            isAuditOk == "tg" ||
            state == "qr" ||
            state == "tj"
          ) {
            this.$alert("只有保存和退回的数据可以修改！", "warning");
            return;
          }
          // 跳转详情页面
          this.$router.push({
            path: "/contractRecordDirectlyDetail",
            query: {
              controllerFlg: "update",
              id: this.multipleSelection[0].id
            }
          });
        }
      } else {
        // 未勾选，则提示
        this.$alert("请至少选中一行数据！", "warning");
        return;
      }
    },

    /**
     * 删除的方法
     * @author shuhua
     */
    fun_Del() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 勾选超过一条
        if (this.multipleSelection.length > 1) {
          // 勾选多条时，提示
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
        } else {
          // 状态
          let state = this.multipleSelection[0].state;
          // 是否审核通过
          let isAuditOk = this.multipleSelection[0].isAuditOk;
          // 如果提交，审核中或者审核通过
          if (
            state == "tj" ||
            state == "shz" ||
            isAuditOk == "tg" ||
            state == "qr"
          ) {
            this.$alert(
              "当前所选项目中，存在已提交或审核通过或解除合同失败或确认中的数据，不能删除！",
              "warning"
            );
            return;
          }
          // 弹出询问confirm
          this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            // 获取id
            const id = fun_GetKeys(this.multipleSelection);
            // 发起请求，获取结果集
            fun_PostAction("/contractRecordDirectly/delete?keys=" + id).then(
              res => {
                // 解构res.data
                const { result, msg } = res.data;
                // 判断请求是否成功
                if (result) {
                  // 查询列表
                  this.fun_GetList();
                  // 提示删除成功
                  this.$message.success(msg);
                } else {
                  // 请求失败，提示信息
                  this.$message.error(msg);
                }
              }
            );
          });
        }
      } else {
        // 未勾选，则提示
        this.$alert("请选择一条数据！", "warning");
      }
    },
    /**
     * 打印的方法
     * @author shuhua
     */
    fun_DialogForPrint(data) {
      // 打开弹窗
      this.$refs.printDialog.dialogVisible = true;
      // 主键
      this.$refs.printDialog.id = data.id;
      // 编号
      this.$refs.printDialog.everyIds = data.id;
      // ids
      this.$refs.printDialog.data = data.id;
      // ids
      this.$refs.printDialog.agencyId = data.id;
      // 权限编号
      this.$refs.printDialog.operationNum = data.id;
    },

    /**
     * 打印的方法
     */
    fun_DialogPrint(
      id,
      agency,
      tender,
      agencyRecords,
      bidder,
      lock,
      recordNumber,
      flag
    ) {
      // 发起请求
      fun_Download("/dialogPrint", {
        controller: "contractRecordDirectlyPrint",
        id: id,
        agency: agency,
        tender: tender,
        agencyRecords: agencyRecords,
        lock: lock,
        recordNumber: recordNumber
      }).then(res => {
        const data = new Blob([res.data], { type: "application/pdf" });
        const reader = new FileReader();
        // 如果文件大小等于0
        if (data.size == 0) {
          this.$message.success("文件生成中！");
        } else {
          //
          this.$refs.printDialog.isShow = true;
          // 读取文件
          reader.readAsText(data);
          // 触发onload事件
          reader.onload = () => {
            // json格式数据转换成对象
            if (reader.result.indexOf("result") > -1) {
              const result = JSON.parse(reader.result);
              if (result.result == false) {
                this.$message.error(result.msg);
              }
            } else {
              this.$refs.printDialog.pdfUrl =
                "./static/pdf/web/viewer.html?file=" +
                encodeURIComponent(URL.createObjectURL(data));
            }
          };
        }
      });
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },

    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },

    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },

    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },

    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 查看详情
     * @author shuhua
     */
    fun_LookDetails(e) {
      // 请求参数
      let obj = {
        controllerFlg: "detail",
        id: e.val.id
      };
      // 跳转详情页面
      this.$router.push({
        path: "/contractRecordDirectlyDetail",
        query: obj
      });
    },
    /**
     * 详情
     * @param e
     * @param controllerFlag
     */
    fun_Details(e, controllerFlg) {
      // 请求参数
      let obj = {
        controllerFlg: controllerFlg,
        id: e.id
      };
      // 跳转详情页面
      this.$router.push({
        path: "/contractRecordDirectlyDetail",
        query: obj
      });
    },
    /**
     * 台帐导出的方法
     * @author shuhua
     */
    fun_ImportExcel() {
      try {
        // 请求，获取结果集
        fun_Download("/contractRecordDirectly/export", {
          ...this.form
        }).then(res => {
          // 获取到Content-Disposition;filename
          let fileNames = res.headers["content-disposition"];
          if (fileNames) {
            let regFileNames = fileNames.match(/=(.*)$/)[1];
            // 调用下载文件公共方法
            fun_DownloadFile(res, decodeURIComponent(regFileNames));
            // 关闭加载
            this.loading = false;
          } else {
            // 关闭加载
            this.loading = false;
            // 提示请求失败消息
            this.$message.error("文件不存在！");
          }
        });
      } catch {}
    }
  }
};
